import { useTranslation } from '../../../../hooks/useTranslation';
import { supportedCalendarProviders } from '../../../../interfaces/Calendar';
import Text from '../../../shared/Text/Text';
import StyledFlag from '../../AgentLineStep/StyledFlag';
import StyledCalendarName from './StyledCalendarName';
import StyledLabel from './StyledLabel';
import StyledStatus from './StyledStatus';

interface ConnectedCalendarIndicatorProps {
  label?: string;
  status?: string;
  iconPath?: string;
  calendarProvider?: string;
}

const ConnectedCalendarIndicator: React.FC<ConnectedCalendarIndicatorProps> = ({
  label,
  status = 'CONNECTED',
  iconPath = supportedCalendarProviders['outlook'].icon,
  calendarProvider = supportedCalendarProviders['outlook'].name,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Text type="label">{label ?? t('Calendars')}</Text>
      <StyledLabel>
        <StyledFlag
          src={iconPath}
          alt={`Icon of the calendar provider ${calendarProvider}`}
        />
        <StyledCalendarName>
          <span>{calendarProvider}</span>
          <StyledStatus>{status}</StyledStatus>
        </StyledCalendarName>
      </StyledLabel>
    </>
  );
};

export default ConnectedCalendarIndicator;
